// Where the review's back button goes. React Router keeps the position of the
// current entry in the browser's history state (`idx`, 0 for the first entry
// of this visit). Above 0 the review was opened from another screen of the
// app: going back returns there, with its scroll restored by the router.
// At 0 (a bookmark, a new tab, a reload of a link) there is nothing of ours
// to go back to, so the button opens Home instead.

export type BackTarget = { kind: 'history' } | { kind: 'home'; path: '/' };

/** The target for a history state as React Router writes it. */
export function backTarget(state: unknown): BackTarget {
  const idx = typeof state === 'object' && state !== null ? (state as { idx?: unknown }).idx : undefined;
  return typeof idx === 'number' && idx > 0 ? { kind: 'history' } : { kind: 'home', path: '/' };
}

/** The button's words for a target. */
export function backLabel(target: BackTarget): string {
  return target.kind === 'history' ? 'Back' : 'Home';
}

/** What `navigate` is asked: back one entry, or a path. */
export type Navigate = (to: number | string) => void;

/**
 * The back button for a history state, read when the bar renders: the
 * review's own address rewrites replace its entry, so the position in
 * history is the one it was opened at.
 */
export function backButton(historyState: unknown, navigate: Navigate): { label: string; onBack(): void } {
  const target = backTarget(historyState);
  return { label: backLabel(target), onBack: () => (target.kind === 'history' ? navigate(-1) : navigate(target.path)) };
}
